import type { ReportBundle, ReportDimension } from '../../shared/types.js';

function gapLine(d: ReportDimension): string {
  if (!d.evidenced) return `### ${d.name}\n\n- Assigned ${d.assigned.level} · **no evidence logged**\n`;
  const entries = d.entries
    .map((e) => `  - ${e.scope === 'stretch' ? '(stretch) ' : ''}${e.title} — ${e.demonstrated_level}`)
    .join('\n');
  return (
    `### ${d.name} — ${d.assigned.level} → ${d.evidenced.level} (${(d.delta ?? 0) >= 0 ? '+' : ''}${d.delta})\n\n` +
    `- Assigned (${d.assigned.level}): ${d.assigned.descriptor}\n` +
    `- Evidenced (${d.evidenced.level}): ${d.evidenced.descriptor}\n` +
    (entries ? `- Supporting:\n${entries}\n` : '')
  );
}

function onePagerLine(d: ReportDimension): string {
  if (!d.strongest || !d.evidenced) return `- **${d.name}**: _no confirmed evidence this period._`;
  const s = d.strongest;
  const proof = s.evidence.map((e) => e.label ?? e.url ?? e.kind).join(', ');
  return (
    `- **${d.name}** (Evidenced ${d.evidenced.level}): ${s.title}` +
    `${s.scope === 'stretch' ? ' _(stretch)_' : ''} — "${d.evidenced.descriptor}"` +
    `${s.impact ? ` ↳ ${s.impact}` : ''}${proof ? ` · ${proof}` : ''}`
  );
}

export function reportToMarkdown(report: ReportBundle): string {
  const { config, summary, period } = report;
  return [
    `# Levelling case`,
    ``,
    `Assigned ${config.assigned_level} · arguing to ${config.target_level} · ` +
      `${summary.dimensions_meeting_target}/${summary.dimensions_total} dimensions ≥ target · ` +
      `${period.from} → ${period.to}${period.include_drafts ? ' · includes drafts' : ''}`,
    ``,
    `## Gap report`,
    ``,
    ...report.dimensions.map(gapLine),
    `## HR one-pager`,
    ``,
    ...report.dimensions.map(onePagerLine),
    ``,
  ].join('\n');
}
